module.exports = __webpack_public_path__ + "static/media/Nokia 220 Black.78002d3c.png";